var map = {
	"./1-1.svg": "11b5",
	"./1-2.svg": "56ff",
	"./1-3.svg": "3a5d",
	"./1-4.svg": "7598",
	"./1-5.svg": "84cb",
	"./2-1.svg": "1153",
	"./2-2.svg": "b330",
	"./2-3.svg": "7785",
	"./2-4.svg": "3579",
	"./2-5.svg": "46e9",
	"./3-1.svg": "1c1e",
	"./3-2.svg": "2b6e",
	"./3-3.svg": "548f",
	"./3-4.svg": "84f5",
	"./3-5.svg": "81c6",
	"./4-1.svg": "28b9",
	"./4-2.svg": "3bca",
	"./4-3.svg": "e9b3",
	"./4-4.svg": "5503",
	"./4-5.svg": "1abb",
	"./5-1.svg": "4c57",
	"./5-2.svg": "cb89",
	"./5-3.svg": "b67d",
	"./5-4.svg": "5b50a",
	"./5-5.svg": "27b8"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "eafd";